import { createStyles, makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles(() =>
  createStyles({
    root: {
      display: 'block',
      fontWeight: 'bold',
      textTransform: 'uppercase',
      margin: 'unset',
      fontFamily: 'Iliad-Regular'
    }
  })
)
